<app-navbar />

<div class="ia-container">

  <!-- ── Hero Header ───────────────────────────── -->
  <div class="ia-hero">
    <div class="ia-hero-left">
      <div class="ia-hero-icon">
        <img src="https://cedae.vibetex.com.br/images/ia.png" alt="IA" class="ia-hero-icon-img" />
      </div>
      <div>
        <h1 class="ia-hero-title">VibeService IA</h1>
        <p class="ia-hero-sub">
          <span class="ia-online-dot"></span>
          Inteligência Artificial · VibeTex Cedae
        </p>
      </div>
    </div>
    <button class="ia-btn-clear" (click)="clearChat()" title="Limpar conversa">
      <i class="fas fa-rotate-left me-2"></i>Nova conversa
    </button>
  </div>

  <!-- ── Quick Actions ─────────────────────────── -->
  <div class="ia-quick-bar">
    <span class="ia-quick-label">Sugestões:</span>
    <div class="ia-quick-list">
      <button
        *ngFor="let a of visibleQuickActions"
        class="ia-quick-chip"
        (click)="sendQuickAction(a.prompt)"
        [disabled]="isTyping"
      >
        <i [class]="a.icon"></i>
        {{ a.label }}
      </button>
    </div>
  </div>

  <!-- ── Chat Body ─────────────────────────────── -->
  <div class="ia-chat-body" #chatBody (click)="onChatBodyClick($event)">

    <ng-container *ngFor="let msg of messages">

      <!-- Mensagem do assistente -->
      <div class="ia-msg-row ia-msg-assistant" *ngIf="msg.role === 'assistant'">
        <div class="ia-msg-avatar">
          <img src="https://cedae.vibetex.com.br/images/ia.png" alt="IA" class="ia-avatar-img" />
        </div>
        <div class="ia-msg-content">
          <div class="ia-bubble-assistant-wrap">
            <div class="ia-msg-actions">
              <button class="ia-copy-btn-float" (click)="copyMessage(msg.content)" title="Copiar texto">
                <i class="fas fa-copy"></i>
              </button>
              <button class="ia-copy-btn-float ia-pdf-btn-float" (click)="sendQuickAction('Por favor, gere um PDF da última resposta que você deu.')" title="Gerar PDF">
                <i class="fas fa-file-pdf"></i>
              </button>
            </div>
            <div class="ia-bubble ia-bubble-assistant">
              <div class="ia-bubble-text" [innerHTML]="msg.safeContent"></div>
              <div class="ia-attachment" *ngIf="msg.attachment">
                <button type="button" class="ia-attachment-btn" (click)="downloadAttachment(msg)">
                  <i class="fas fa-file-pdf"></i>
                  Baixar {{ msg.attachment.nomeArquivo }}
                </button>
              </div>
            </div>
          </div>
          <span class="ia-msg-time">{{ msg.timestamp | date:'HH:mm' }}</span>
        </div>
      </div>

      <!-- Mensagem do usuário -->
      <div class="ia-msg-row ia-msg-user" *ngIf="msg.role === 'user'">
        <div class="ia-msg-content ia-msg-content-right">
          <div class="ia-bubble-user-wrap">
            <button class="ia-copy-btn-float" (click)="copyMessage(msg.content)" title="Copiar texto">
              <i class="fas fa-copy"></i>
            </button>
            <div class="ia-bubble ia-bubble-user">{{ msg.content }}</div>
          </div>
          <span class="ia-msg-time ia-msg-time-right">{{ msg.timestamp | date:'HH:mm' }}</span>
        </div>
        <div class="ia-msg-avatar ia-msg-avatar-user">
          <i class="fas fa-user"></i>
        </div>
      </div>

    </ng-container>

    <!-- Typing indicator -->
    <div class="ia-msg-row ia-msg-assistant" *ngIf="isTyping">
      <div class="ia-msg-avatar ia-msg-avatar-typing">
        <img src="https://cedae.vibetex.com.br/images/ia.gif" alt="IA pensando" class="ia-avatar-img ia-avatar-img-typing" />
      </div>
      <div class="ia-bubble ia-bubble-assistant ia-bubble-typing">
        <span class="ia-dot"></span>
        <span class="ia-dot"></span>
        <span class="ia-dot"></span>
      </div>
    </div>

  </div>

  <!-- ── Input Area ─────────────────────────────── -->
  <div class="ia-input-area">
    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()" class="ia-input-form">
      <textarea
        #messageInput
        formControlName="message"
        class="ia-input"
        placeholder="Digite sua mensagem... (Enter para enviar, Shift+Enter para nova linha)"
        rows="1"
        (input)="onInput($event)"
        (keydown)="onKeyDown($event)"
      ></textarea>
      <button type="submit" class="ia-send-btn" [disabled]="chatForm.invalid || isTyping">
        <i class="fas fa-paper-plane"></i>
      </button>
    </form>
    <p class="ia-disclaimer">
      <i class="fas fa-circle-info me-1"></i>
      <!-- O assistente pode cometer erros. Verifique informações importantes diretamente no sistema. -->
    </p>
  </div>

</div>
